export default __webpack_public_path__ + "f5ec48c6aeb510584c4c17d1acf68f13.png";